import {
  CHANGE_INFOGRAPHICS_EDITOR,
  INFOGRAPHICS_CREATE,
  INFOGRAPHICS_LOCK,
  INFOGRAPHICS_UNLOCK,
  LOCK_INFOGRAPHICS_ACTION,
  UNLOCK_INFOGRAPHICS_ACTION,
  UPDATE_INFOGRAPHICS_ACTION,
} from 'src/redux/constants';
import type { ViewAction, ViewActionPayload } from 'src/redux/viewState/types';

export const UpdateInfographicsAction = (
  data: ViewActionPayload,
): ViewAction => {
  return {
    type: UPDATE_INFOGRAPHICS_ACTION,
    dataKey: INFOGRAPHICS_CREATE,
    value: { value: data },
  };
};

export const LockInfographicsAction = (data: ViewActionPayload): ViewAction => {
  return {
    type: LOCK_INFOGRAPHICS_ACTION,
    dataKey: INFOGRAPHICS_LOCK,
    value: { value: data },
  };
};

export const UnlockInfographicsAction = (
  data: ViewActionPayload,
): ViewAction => {
  return {
    type: UNLOCK_INFOGRAPHICS_ACTION,
    dataKey: INFOGRAPHICS_UNLOCK,
    value: { value: data },
  };
};

export const UnlockInfographicsActionSuccess = (
  data: ViewActionPayload,
): ViewAction => {
  return {
    type: CHANGE_INFOGRAPHICS_EDITOR,
    value: data,
  };
};
